<template>
  <div class="user-card">
    <!-- Remove Icon -->
    <button class="remove-btn" @click.stop="showRemoveConfirm(user, $event)">
      <i class="far fa-minus"></i>
    </button>

    <div class="card-image" @click="$emit('select-user', user)">
      <img :src="user.profilePicture || require('@/assets/images/user_img_placeholder.jpg')" 
      alt="User Image" @error="onImageError" />
    </div>
    <div class="card-content" @click="$emit('select-user', user)">
      <h4 class="card-title">{{ user.firstName }} {{ user.lastName }}</h4>
      <p class="card-text">{{ user.email }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UserCard',
  props: {
    user: {
      type: Object,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    }
  },
  methods: {
    ...mapActions('user', ['removeChildrenFromParent']),
    async removeChildren(user){
      try {
        const removed = await this.removeChildrenFromParent({
          "studentIDs": [this.user.id],
        });

        if(removed) {
          this.onRemove?.call(user.id);
        }
      } catch (error) {
        // console.error('Failed to fetch users:', error);
        this.$bvToast.toast('Failed to remove user', { title: 'Error', variant: 'danger', solid: true });
      }
    },
    onImageError(event) {
      event.target.src = require('@/assets/images/user_img_placeholder.jpg');
    },
    showRemoveConfirm(user, event) {
      event.preventDefault();
      event.stopPropagation();

      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to remove: ${user.firstName} ${user.lastName}?`,
        {
          title: "Confirm Remove",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          centered: true
        }
      )
        .then(async confirmed => {
          if (confirmed) {
            await this.removeChildren(user);
          }
        });
    }
  },
};
</script>

<style scoped>
.user-card {
  position: relative;
  flex: 0 0 30%;
  margin-top: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.3s, background-color 0.3s;
}

.user-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #f8f9fa;
}

.user-card.selected {
  border-color: var(--primary-color);
  background-color: #e9ecef;
}

.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  z-index: 3;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.remove-btn:hover {
  background: darkred;
}

.card-image {
  position: relative;
  width: 100%;
  height: 200px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.card-content {
  padding: 1rem;
}

.card-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 1200px) {
  .user-card {
    flex: 0 0 44%;
  }
}

@media (max-width: 768px) {
  .user-card {
    flex: 0 0 100%;
  }
}
</style>
